document.addEventListener("DOMContentLoaded", function () {

  // Change product card image when a color swatch is clicked
  document.body.addEventListener("change", function (e) {
    const swatch = e.target.closest(".ColorSwatch__Radio");
    if (!swatch) return;

    // get image URL from data attribute
    const newImage = swatch.getAttribute("data-image-url");
    if (!newImage) return;

    // find product card container (closest card)
    const productCard = swatch.closest(".ProductItem");
    if (!productCard) return;

    // find product card image element
    const img = productCard.querySelector("img, .ProductItem__Image img, .ProductItem__ImageWrapper img");
    if (!img) return;

    // Update image src
    img.src = newImage.replace("{width}x", "600x");

    // Also update srcset if exists
    if (img.srcset) {
      img.srcset = newImage.replace("{width}", "600");
    }
  });

});

document.querySelectorAll(".ProductItem").length

document.addEventListener('DOMContentLoaded', async () => {

  const boxes = document.querySelectorAll('.main-collection-box');
  const productGrid = document.querySelector('.dynamic-products');
  const titleEl = document.getElementById('collection-title');
  const descEl = document.getElementById('collection-desc');
  const subWrapper = document.querySelector('.subcollection-tabs-wrapper');
  const sortSelect = document.getElementById('sort-by');

  let currentHandle = null;

  /* -------------------------------------------
      FUNCTION: REINIT PRESTIGE THEME SCRIPTS
     ------------------------------------------- */
  const reinitPrestige = () => {

    // Required theme components
    if (window.theme) {
      if (theme.ProductGrid?.init) theme.ProductGrid.init();
      if (theme.QuickView?.init) theme.QuickView.init();
      if (theme.ProductItem?.init) theme.ProductItem.init();
    }

    // LazyLoad update if exists
    if (window.LazyLoad?.update) LazyLoad.update();

    // --- KEY FIX: Force ProductItem instances ---
    document.querySelectorAll('.ProductItem').forEach(item => {
      try {
        new theme.ProductItem(item);
      } catch (e) {
        console.warn("ProductItem init failed:", e);
      }
    });

    // --- IMPORTANT: Tell Prestige variants have changed ---
    document.dispatchEvent(new CustomEvent('variant:changed'));
  };


  /* -------------------------------------------
      FUNCTION: EQUAL HEIGHT PRODUCT CARDS
     ------------------------------------------- */
  const setEqualHeights = () => {
    const grid = document.querySelector('.dynamic-products .ProductList--grid');
    if (!grid) return;

    const cards = grid.querySelectorAll('.ProductItem.custom-product-card-item');
    if (!cards.length) return;

    cards.forEach(c => c.style.height = 'auto'); // Reset

    let max = 0;
    cards.forEach(c => {
      let h = c.offsetHeight;
      if (h > max) max = h;
    });

    cards.forEach(c => c.style.height = max + 'px');
  };

  /* -------------------------------------------
      FUNCTION: LOAD PRODUCTS (AJAX)
     ------------------------------------------- */
  async function loadCollection(handle, title, desc, sort = '') {
    showLoader();   // ⭐ SHOW LOADER BEFORE FETCH
    currentHandle = handle;

    try {
      let url = `/collections/${handle}?view=all-products-ajax`;
      if (sort) url += `&sort_by=${sort}`;

      const res = await fetch(url);
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const newGrid = html.querySelector('.CollectionInner__Products, .ProductListWrapper, .ProductList');

      if (newGrid) {
        productGrid.innerHTML = newGrid.outerHTML;

        reinitPrestige();
        setEqualHeights();

      } else {
        productGrid.innerHTML = '<p>No products found.</p>';
      }

      // Replace title and description. A div keeps block HTML inside
      // the container, so this does not leave a second copy on the page.
      if (titleEl) titleEl.innerHTML = title;
      if (descEl) descEl.innerHTML = desc;

    } catch (e) {
      console.error('Load failed:', e);
      productGrid.innerHTML = '<p>Failed to load products.</p>';
    }
  }

  /* -------------------------------------------
      FUNCTION: LOAD SUB COLLECTION TABS
     ------------------------------------------- */
  function loadSubcollections(box) {
    const subData = box.querySelector('.hidden-subcollections');
    const nextHtml = subData ? subData.innerHTML : '';
    if (subWrapper.innerHTML.trim() !== nextHtml.trim()) {
      subWrapper.innerHTML = nextHtml;
    }

    // Add data-title/data-desc if missing
    subWrapper.querySelectorAll('.subcollection-tab').forEach(tab => {
      if (!tab.dataset.title) tab.dataset.title = tab.textContent.trim();
      if (!tab.dataset.desc) tab.dataset.desc = '';
    });
  }

  /* -------------------------------------------
    CLICK ON SUBCOLLECTION TABS (AJAX)
   ------------------------------------------- */
  // ✅ Updated for delegation fix
  subWrapper.addEventListener("click", async (e) => {
    const tab = e.target.closest(".subcollection-tab");
    if (!tab) return;

    e.preventDefault();

    const handle = tab.dataset.handle;
    if (!handle) return;

    // Remove active from all subcollection tabs
    subWrapper.querySelectorAll(".subcollection-tab").forEach(t => t.classList.remove("active"));
    tab.classList.add("active");

    // Reset sort
    sortSelect.value = 'manual';

    // Load products with subcollection title/desc
    const subTitle = tab.dataset.title || tab.textContent.trim();
    const subDesc  = tab.dataset.desc || '';

    await loadCollection(handle, subTitle, subDesc);
  });

  /* -------------------------------------------
      INITIAL LOAD (FINAL FIX)
  ------------------------------------------- */
  if (boxes.length) {
    const first = boxes[0];
    first.classList.add('active');

    loadSubcollections(first);

    const firstTitle = first.dataset.title || '';
    const firstDesc = first.dataset.desc || '';
    const alreadyRendered = productGrid && productGrid.querySelector('.ProductList');

    if (alreadyRendered) {
      if (titleEl && !titleEl.textContent.trim()) titleEl.innerHTML = firstTitle;
      reinitPrestige();
      setEqualHeights();
    } else {
      await loadCollection(first.dataset.handle, firstTitle, firstDesc);
    }
  }

  /* -------------------------------------------
      CLICK ON MAIN COLLECTION BOX
     ------------------------------------------- */
  boxes.forEach(box => {
    box.addEventListener('click', async () => {
      boxes.forEach(b => b.classList.remove('active'));
      box.classList.add('active');

      loadSubcollections(box);

      const mainTitle = box.dataset.title || '';
      const mainDesc = box.dataset.desc || '';

      sortSelect.value = 'manual'; // reset sort

      await loadCollection(box.dataset.handle, mainTitle, mainDesc);
    });
  });

  /* -------------------------------------------
      SORTING
     ------------------------------------------- */
  sortSelect.addEventListener('change', async e => {
    if (!currentHandle) return;
    await loadCollection(currentHandle, titleEl.textContent, descEl.textContent, e.target.value);
  });

  /* -------------------------------------------
      WINDOW RESIZE = RECALC HEIGHT
     ------------------------------------------- */
  window.addEventListener('resize', setEqualHeights);

  /* -------------------------------------------
    FUNCTION: SHOW LOADER
   ------------------------------------------- */
  function showLoader() {
    productGrid.innerHTML = `
      <div class="simple-loader">
        <div class="loader-circle"></div>
      </div>
    `;
  }

   /* -------------------------------------------
     Main Collection Slider 
     ------------------------------------------- */

     const grid = document.querySelector(".main-collections-grid");
  const prev = document.querySelector(".main-slider-arrow.prev");
  const next = document.querySelector(".main-slider-arrow.next");

  if (!grid) return;

  function isMobile() {
    return window.innerWidth <= 574;
  }

  function hasOverflow() {
    return grid.scrollWidth > grid.clientWidth + 2;
  }

  function getSlideAmount() {
    const firstCard = grid.querySelector(".main-collection-box");
    if (!firstCard) return 120;

    const cardStyles = window.getComputedStyle(firstCard);
    const gap = parseInt(window.getComputedStyle(grid).gap || 0);

    return firstCard.offsetWidth + gap;
  }

  function updateState() {
    if (!isMobile()) {
      grid.classList.remove("is-slider");
      prev.classList.add("hidden");
      next.classList.add("hidden");
      return;
    }

    grid.classList.remove("is-slider");

    requestAnimationFrame(() => {
      if (hasOverflow()) {
        grid.classList.add("is-slider");
        prev.classList.remove("hidden");
        next.classList.remove("hidden");
      } else {
        prev.classList.add("hidden");
        next.classList.add("hidden");
      }
    });
  }

  updateState();
  window.addEventListener("resize", updateState);

  next.addEventListener("click", () => {
    grid.scrollBy({ left: getSlideAmount(), behavior: "smooth" });
  });

  prev.addEventListener("click", () => {
    grid.scrollBy({ left: -getSlideAmount(), behavior: "smooth" });
  });



   /* ==========================
     ⏱️ 2 SECOND DELAY (KEY FIX)
     ========================== */
  setTimeout(() => {
    updateState();
  }, 2000);

  window.addEventListener("resize", () => {
    setTimeout(updateState, 300);
  });

  next.addEventListener("click", () => {
    grid.scrollBy({ left: getSlideAmount(), behavior: "smooth" });
  });

  prev.addEventListener("click", () => {
    grid.scrollBy({ left: -getSlideAmount(), behavior: "smooth" });
  });

});

